import type { MetadataEntryConfig } from './CSVEnumSelector.js'
import type { HabitatTypeDTO, HabitatTypeKey} from '../../../../../../Generated/HabitatType.js';
import { HabitatTypes } from '../../../../../../Generated/HabitatType.js'
import type { CollectionTypeDTO, CollectionTypeKey } from '../../../../../../Generated/CollectionType.js';
import { CollectionTypes } from '../../../../../../Generated/CollectionType.js'
import type { ExtractionKitDTO, ExtractionKitKey } from '../../../../../../Generated/ExtractionKit.js';
import { ExtractionKits } from '../../../../../../Generated/ExtractionKit.js'
import type { LocalityTypeDTO, LocalityTypeKey } from '../../../../../../Generated/LocalityType.js';
import { LocalityTypes } from '../../../../../../Generated/LocalityType.js'
import type { MatrixTypeDTO, MatrixTypeKey } from '../../../../../../Generated/MatrixType.js';
import { MatrixTypes } from '../../../../../../Generated/MatrixType.js'
import type { SequencerDTO, SequencerKey } from '../../../../../../Generated/Sequencer.js';
import { Sequencers } from '../../../../../../Generated/Sequencer.js'
import type { SequencingChemistryDTO, SequencingChemistryKey } from '../../../../../../Generated/SequencingChemistry.js';
import { SequencingChemistrys } from '../../../../../../Generated/SequencingChemistry.js'
import type { TrapTypeDTO, TrapTypeKey } from '../../../../../../Generated/TrapType.js';
import { TrapTypes } from '../../../../../../Generated/TrapType.js'

export const HabitatTypeConfig: MetadataEntryConfig<HabitatTypeKey, HabitatTypeDTO> = {
  enumType: HabitatTypes,
  label: "Habitat Types",
  type: "habitatType",
  helpText: "Select which habitat",
  setter: (p, value) => { p.habitatType = value },
  setterCustom: (p, value) => { p.habitatTypeCustom = value },
}

export const CollectionTypeConfig: MetadataEntryConfig<CollectionTypeKey, CollectionTypeDTO> = {
  enumType: CollectionTypes,
  label: "Collection Types",
  type: "collectionType",
  helpText: "Select which collection type",
  setter: (p, value) => { p.collectionType = value },
  setterCustom: (p, value) => { p.collectionTypeCustom = value },
}

export const ExtractionKitConfig: MetadataEntryConfig<ExtractionKitKey, ExtractionKitDTO> = {
  enumType: ExtractionKits,
  label: "Extraction Kits",
  type: "extractionKit",
  helpText: "Select which extraction kit",
  setter: (p, value) => { p.extractionKit = value },
  setterCustom: (p, value) => { p.extractionKitCustom = value },
}

export const LocalityTypeConfig: MetadataEntryConfig<LocalityTypeKey, LocalityTypeDTO> = {
  enumType: LocalityTypes,
  label: "Locality Types",
  type: "localityType",
  helpText: "Select which locality type",
  setter: (p, value) => { p.localityType = value },
  setterCustom: (p, value) => { p.localityTypeCustom = value },
}

export const MatrixTypeConfig: MetadataEntryConfig<MatrixTypeKey, MatrixTypeDTO> = {
  enumType: MatrixTypes,
  label: "Matrix Types",
  type: "matrixType",
  helpText: "Select which matrix type",
  setter: (p, value) => { p.matrixType = value },
  setterCustom: (p, value) => { p.matrixTypeCustom = value },
}

export const SequencerConfig: MetadataEntryConfig<SequencerKey, SequencerDTO> = {
  enumType: Sequencers,
  label: "Sequencers",
  type: "sequencer",
  helpText: "Select which sequencer",
  setter: (p, value) => { p.sequencer = value },
  setterCustom: (p, value) => { p.sequencerCustom = value },
}

export const SequencingChemistryConfig: MetadataEntryConfig<SequencingChemistryKey, SequencingChemistryDTO> = {
  enumType: SequencingChemistrys,
  label: "Sequencing Chemistry",
  type: "sequencingChemistry",
  helpText: "Select which sequencing chemistry",
  setter: (p, value) => { p.sequencingChemistry = value },
  setterCustom: (p, value) => { p.sequencingChemistryCustom = value },
}

export const TrapTypeConfig: MetadataEntryConfig<TrapTypeKey, TrapTypeDTO> = {
  enumType: TrapTypes,
  label: "Trap Types",
  type: "trapType",
  helpText: "Select which trap type",
  setter: (p, value) => { p.trapType = value },
  setterCustom: (p, value) => { p.trapTypeCustom = value },
}